'use client';
import { useEffect } from 'react';

import { init } from '@fullstory/browser';
import { config } from '@/config';

const defaultOptions = {
  debug: false,
  host: 'fullstory.com',
  orgId: 'A7EM7',
  namespace: 'FS',
};

export function FullStory() {
  useEffect(() => {
    if (config.nodeEnv !== 'development') {
      init(defaultOptions);
    }
  }, []);

  return <></>;
}
